import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks/useStores';
import Button from 'ati-ui-react/components/Button/v3';

import { ToFormButtonContainer } from './ToFormButtonStyles';

const ToFormButton: FC = observer(({ path }: any) => {
  const {
    profileStore: { isUser },
    findTrucksStore: { tabLocation },
    popupStore: { openLoginPopup },
  } = useStores();

  const onHandleClickAddAdvert = () => {
    if (!isUser) {
      openLoginPopup(`/cabinet/form?tab=${tabLocation}`);
    } else {
      path.history.push(`/cabinet/form?tab=${tabLocation}`);
    }
  };

  return (
    <ToFormButtonContainer onClick={onHandleClickAddAdvert}>
      <Button className="to-form-button experimental-button" filled={false} size="small">
        <span className="inner-description-container">
          <span className="free">Бесплатно</span>
          <span>Добавить объявление</span>
        </span>
      </Button>
    </ToFormButtonContainer>
  );
});

export default ToFormButton;
